import i18n from "../i18n";

// Locale courante pour les formats de dates / nombres / devises
export const i18nLocale = () => {
  const raw = String(i18n.language || "en").split("@")[0];
  try { new Intl.DateTimeFormat(raw); return raw; } catch { return "en"; }
};

export const fmtCurrency = (value, currency = "EUR") =>
  new Intl.NumberFormat(i18nLocale(), { style: "currency", currency }).format(value);

export const fmtNumber = (value) => new Intl.NumberFormat(i18nLocale()).format(value);

const WD_INDEX = { sunday: 0, monday: 1, tuesday: 2, wednesday: 3, thursday: 4, friday: 5, saturday: 6 };

// Nom localisé d'un jour de la semaine à partir de la clé anglaise ("monday"…)
export const weekdayLabel = (key, style = "long") => {
  const idx = WD_INDEX[key];
  if (idx === undefined) return key;
  const d = new Date(Date.UTC(2024, 0, 7 + idx)); // 2024-01-07 = dimanche
  const s = d.toLocaleDateString(i18nLocale(), { weekday: style, timeZone: "UTC" });
  return s.charAt(0).toUpperCase() + s.slice(1);
};

// "il y a 5 min" localisé via Intl.RelativeTimeFormat
export const timeAgo = (iso) => {
  try {
    const diff = Date.now() - new Date(iso).getTime();
    const rtf = new Intl.RelativeTimeFormat(i18nLocale(), { numeric: "auto" });
    const min = Math.floor(diff / 60000);
    if (min < 60) return rtf.format(-min, "minute");
    const h = Math.floor(min / 60);
    if (h < 24) return rtf.format(-h, "hour");
    return rtf.format(-Math.floor(h / 24), "day");
  } catch { return ""; }
};
